/* eslint-disable no-empty, no-redeclare, no-unused-vars */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { laydate } from './laydate.js';
import { form } from './form.js';
import { upload } from './upload.js';
import { laypage } from './laypage.js';
import { layer } from './layer.js';
import { createMediaCategoryTree } from './mediaCategoryTree.js';
import { getMediaManageLayerOptions, getMediaDialogFormOptions, createMediaFormFieldHtml, createMediaConfirmHtml, createMediaMobileBar, bindMediaMobilePanels, createMediaSelectionHelper, createMediaDialogFooter, bindMediaDialogFooter } from './mediaManageResponsive.js';

var $ = jquery;
var Fancybox = window.layui && window.layui.fancybox ? window.layui.fancybox : window.Fancybox;
	var trimText = function(value){
		return value == null ? '' : String(value).trim();
	};
	var escapeHtml = function(value){
		return String(value == null ? '' : value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	};
	i18n.set({
		messages: {
			'zh-CN': {
				pictureManage: {
					addGroup: '添加分组',
					allPictures: '所有图片',
					dateRange: '日期范围',
					fileName: '文件名',
					search: '搜索',
					delete: '删除',
					move: '移动',
					uploadPicture: '上传图片',
					selectAllPage: '本页全选',
					selectedCount: '已选 {count} 张',
					selectGroup: '选择分组',
					movePicture: '移动图片',
					moveSuccess: '移动成功',
					moveFailed: '移动失败',
					selectPictureToMove: '请选择要移动的图片?',
					deletePicture: '删除图片',
					confirmDeletePictures: '真的要删除选择的图片吗?',
					deleteSuccess: '删除成功',
					deleteFailed: '删除失败',
					selectPictureToDelete: '请选择要删除的图片?',
					maxSelect: '最多只能选{max}张',
					renameFile: '修改文件名【{name}】',
					fileNameLabel: '文件名',
					renameSuccess: '修改成功',
					renameFailed: '修改失败',
					fileNameRequired: '文件名不能为空',
					newGroup: '新建分组',
					groupName: '分组名称',
					groupNameRequired: '请填写分组名称',
					groupCancel: '取消',
					edit: '修改',
					deleteGroup: '删除分组',
					confirmDeleteGroup: '真的要删除该分组吗?',
					deleteGroupWithChildren: '请先删除子分组',
					selectPicture: '选择图片',
					confirm: '确定',
					cancel: '取消'
				}
			},
			'en-US': {
				pictureManage: {
					addGroup: 'Add Group',
					allPictures: 'All Pictures',
					dateRange: 'Date Range',
					fileName: 'File Name',
					search: 'Search',
					delete: 'Delete',
					move: 'Move',
					uploadPicture: 'Upload Picture',
					selectAllPage: 'Select all on page',
					selectedCount: 'Selected {count}',
					selectGroup: 'Select Group',
					movePicture: 'Move Picture',
					moveSuccess: 'Moved successfully',
					moveFailed: 'Move failed',
					selectPictureToMove: 'Please select picture(s) to move.',
					deletePicture: 'Delete Picture',
					confirmDeletePictures: 'Are you sure you want to delete the selected pictures?',
					deleteSuccess: 'Deleted successfully',
					deleteFailed: 'Delete failed',
					selectPictureToDelete: 'Please select picture(s) to delete.',
					maxSelect: 'You can select up to {max} pictures',
					renameFile: 'Rename File [{name}]',
					fileNameLabel: 'File Name',
					renameSuccess: 'Renamed successfully',
					renameFailed: 'Rename failed',
					fileNameRequired: 'File name is required',
					newGroup: 'New Group',
					groupName: 'Group Name',
					groupNameRequired: 'Please enter a group name',
					groupCancel: 'Cancel',
					edit: 'Edit',
					deleteGroup: 'Delete Group',
					confirmDeleteGroup: 'Are you sure you want to delete this group?',
					deleteGroupWithChildren: 'Please delete child groups first',
					selectPicture: 'Select Picture',
					confirm: 'Confirm',
					cancel: 'Cancel'
				}
			}
		}
	});
	var t = function(key, fallback, params){
		return i18n.translate('pictureManage.' + key, params, { default: fallback });
	};

	var openImagePreview = function(src){
		if(!src){
			return;
		}
		var safeSrc = escapeHtml(src);
		var index = layer.open({
			type: 1,
			title: false,
			closeBtn: 1,
			shadeClose: true,
			resize: false,
			scrollbar: false,
			skin: 'layui-layer-g3ys-form picture-preview-layer',
			area: ['auto', 'auto'],
			maxWidth: 960,
			content: "<div class='picture-preview-wrap'><img src='" + safeSrc + "' alt='preview' class='picture-preview-image'></div>",
			success: function(layero){
				var $image = $(layero).find('.picture-preview-image');
				var recenter = function(){
					var $dialog = $('#layui-layer' + index);
					if(!$dialog.length){
						return;
					}
					var viewportWidth = $(window).width();
					var viewportHeight = $(window).height();
					var dialogWidth = Math.min($dialog.outerWidth(), viewportWidth - 32);
					var dialogHeight = Math.min($dialog.outerHeight(), viewportHeight - 32);
					layer.style(index, {
						width: dialogWidth + 'px',
						height: dialogHeight + 'px',
						top: Math.max((viewportHeight - dialogHeight) / 2, 16) + 'px',
						left: Math.max((viewportWidth - dialogWidth) / 2, 16) + 'px'
					});
				};
				$image.on('load', function(){
					recenter();
				});
				$image.on('error', function(){
					if(Fancybox){
						layer.close(index);
						Fancybox.show([{src:src,type:'image'}]);
					}
				});
				recenter();
			}
		});
	};
	
	function PictureManage(){
		
	}
	var pictureManage = PictureManage;
	
	pictureManage.prototype.options={};
	pictureManage.prototype.init=function(options){
		this.options=options;
		this._state = this._state || {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		};
	}
	pictureManage.prototype.render=function(){
		var state = this._state || (this._state = {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		});
		var picture_data = state.data || {};
		var picture_data_multiple = Array.isArray(state.dataMultiple) ? state.dataMultiple : [];
		var category_id = state.categoryId || 0;
		var init_categorys = state.initCategories;
		var category_tree = state.categoryTree;
		var syncState = function(){
			state.data = picture_data;
			state.dataMultiple = picture_data_multiple;
			state.categoryId = category_id;
			state.initCategories = init_categorys;
			state.categoryTree = category_tree;
		};
		syncState();
		var load=layer.load();
		var pictureUploadUrl=this.options.pictureUploadUrl;
		var pictureDelUrl=this.options.pictureDelUrl;
		var pictureMoveUrl=this.options.pictureMoveUrl;
		var editPictureNameUrl=this.options.editPictureNameUrl;
		var pictureCategory=this.options.pictureCategory;
		var pictureCategoryUrl=this.options.pictureCategoryUrl;
		var pictureCategoryUpdateUrl=this.options.pictureCategoryUpdateUrl;
		var pictureCategoryDelUrl=this.options.pictureCategoryDelUrl;

	var multiple=this.options.multiple;
		var that;
		
		var size = this.options.size;
		var acceptMime = this.options.acceptMime;
		var headers = this.options.headers;
		var field = this.options.field;
		var exts = this.options.exts;
		var pictureUploadData =this.options.pictureUploadData;
		
		var pictureUrl=this.options.pictureUrl;
		var pictureDialogOptions = getMediaDialogFormOptions();
		var picture_s_time=0;
		var picture_e_time=0;
		var picture_total=0;
		var callback=this.options.callback;
		var pictureMax=this.options.pictureMax||12;
		
		var picture_manage_div= this.options.elem+"_picture_manage_div";
		var picture_manage= this.options.elem+"_picture_manage";
		var picture_upload= this.options.elem+"_picture_upload";
		var picture_del= this.options.elem+"_picture_del";
		var picture_move= this.options.elem+"_picture_move";
		var picture_category= this.options.elem+"_picture_category";
		var picture_category_add=this.options.elem+"_picture_category_add";
		var picture_search_input=this.options.elem+"_picture_search_input";
		var picture_search_date=this.options.elem+"_picture_search_date";
		var picture_search_btn=this.options.elem+"_picture_search_btn";
		var picture_mobile_category_toggle=this.options.elem+"_picture_mobile_category_toggle";
		var picture_mobile_search_toggle=this.options.elem+"_picture_mobile_search_toggle";
		var picture_content=this.options.elem+"_picture_content";
		var picture_page=this.options.elem+"_picture_page";
		var picture_confirm= this.options.elem+"_picture_confirm";
		var picture_cancel= this.options.elem+"_picture_cancel";
		var picture_item=this.options.elem+"_picture_item";
		var picture_select_all=this.options.elem+"_picture_select_all";
		var picture_select_all_num=this.options.elem+"_picture_select_all_num";
		var getPictureItems = function(){
			return $("#"+picture_content+" a");
		};
		var getPictureItemData = function(item){
			item=$(item);
			return {
				id:item.attr('data-id'),
				path:item.attr('data-path'),
				src:item.attr('data-src'),
				title:item.find('span').text()
			};
		};
		var pictureSelection = createMediaSelectionHelper({
			multiple: multiple,
			max: pictureMax,
			selectClass: 'picture-item-select',
			getItems: getPictureItems,
			getSelectedItems: function(){
				return picture_data_multiple;
			},
			setSelectedItems: function(items){
				picture_data_multiple = items;
				syncState();
			},
			getSingleSelected: function(){
				return picture_data;
			},
			setSingleSelected: function(item){
				picture_data = item;
				syncState();
			},
			setSelectedCount: function(count){
				$("#"+picture_select_all_num).text(count);
			},
			setSelectAllChecked: function(checked){
				$("#"+picture_select_all).prop('checked', checked);
			},
			getItemData: getPictureItemData,
			markSelected: function(item){
				$("#"+picture_item+"_"+item.id).addClass('picture-item-select');
			},
			onLimit: function(){
				layer.msg(t('maxSelect', '最多只能选{max}张', {max: pictureMax}));
			}
		});
		var updatePictureSelectedCount = pictureSelection.updateSelectedCount;
		var syncPictureSelectAll = pictureSelection.syncSelectAll;
		var applyPictureSelections = pictureSelection.applySelections;
		var setPictureItemSelected = pictureSelection.setItemSelected;
		var bindPictureItems = pictureSelection.bindItems;
		var syncSelectedPicturesFromDom = function(){
			var selectedItems = [];
			getPictureItems().filter('.picture-item-select').each(function(){
				selectedItems.push(getPictureItemData(this));
			});
			if(multiple){
				picture_data_multiple = selectedItems;
			}else{
				picture_data = selectedItems.length ? selectedItems[0] : {};
			}
			syncState();
		};
		var mobilePanels = null;
		
		if($("#"+picture_manage_div).length>0){

		}else{
			var html="";
			html=html+'<div id="'+picture_manage_div+'" class="picture-manage">';
			html=html+'<div id="'+picture_manage+'" class="media-manage-shell" data-mobile-search="closed" data-mobile-category="closed">';
			html=html+createMediaMobileBar({
				categoryTriggerId: pictureCategory ? picture_mobile_category_toggle : '',
				searchTriggerId: picture_mobile_search_toggle,
				categoryText: t('allPictures', '所有图片'),
				searchText: t('search', '搜索')
			});
			html=html+'<div class="media-manage-stage'+(pictureCategory ? ' media-manage-body-with-side' : '')+'">';
			if(pictureCategory){
				html=html+'<div class="media-manage-side picture-manage-side">';
				html=html+'<h3 class="picture-manage-category-title" id="'+picture_category_add+'">'+t('addGroup', '添加分组')+'</h3>';
				html=html+'<div class="picture-manage-left-content" id="'+picture_category+'"></div>';
				html=html+'</div>';
				html=html+'<div class="picture-manage-right media-manage-main">';
			}else{
				html=html+'<div class="picture-manage-right media-manage-main">';
			}
			
			html=html+'<div class="picture-manage-header">';
			html=html+'<label>'+t('dateRange', '日期范围')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+picture_search_date+'" >';
			html=html+'<label>'+t('fileName', '文件名')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+picture_search_input+'" >';
			html=html+'<button class="layui-btn layui-btn-sm" id="'+picture_search_btn+'"><i class="layui-icon">&#xe615;</i>'+t('search', '搜索')+'</button>';
			html=html+'</div>';
			if(pictureCategory){
				html=html+'<div class="picture-content" id="'+picture_content+'">';
			}else{
				html=html+'<div class="picture-content picture-content-no" id="'+picture_content+'">';
			}
			html=html+'</div>';
			html=html+'<div class="picture_page">';
			if(multiple){
			html=html+'<div class="picture_page_left">';
			html=html+'<input type="checkbox" id="'+picture_select_all+'"/><span>'+t('selectAllPage', '本页全选')+'</span><label>'+t('selectedCount', '已选 {count} 张', {count: '__COUNT__'}).replace('__COUNT__', '<span id="'+picture_select_all_num+'">0</span>')+'</label>';
			html=html+'</div>';
			}
			html=html+'<div class="picture_page_right" id="'+picture_page+'"></div>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'</div>';
			var pictureFooterActions='';
			pictureFooterActions=pictureFooterActions+'<a href="javascript:;" id="'+picture_del+'" class="layui-btn layui-btn-sm layui-btn-danger media-manage-action media-manage-action-delete">'+t('delete', '删除')+'</a>';
			if(pictureCategory){
				pictureFooterActions=pictureFooterActions+'<a href="javascript:;" id="'+picture_move+'" class="layui-btn layui-btn-sm layui-btn-normal media-manage-action media-manage-action-move">'+t('move', '移动')+'</a>';
			}
			pictureFooterActions=pictureFooterActions+'<a href="javascript:;" id="'+picture_upload+'" class="layui-btn layui-btn-sm layui-bg-green media-manage-action media-manage-action-upload">'+t('uploadPicture', '上传图片')+'</a>';
			html=html+createMediaDialogFooter({
				actionsHtml: pictureFooterActions,
				confirmId: picture_confirm,
				cancelId: picture_cancel,
				confirmText: t('confirm', '确定'),
				cancelText: t('cancel', '取消')
			});
			html=html+'</div>';
			$('body').append(html);
			
			if(multiple){
				$("#"+picture_select_all).click(function(){
					var checked=$(this).prop('checked');
					getPictureItems().each(function(){
						setPictureItemSelected(this, checked);
					});
				});
			}
			/*时间范围选择*/
			laydate.render({
				elem: '#'+picture_search_date
				,range: true
				,done: function(value, date, endDate){
					picture_s_time=Date.parse(date.year+"-"+date.month+"-"+date.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000;
					picture_e_time=Date.parse(endDate.year+"-"+endDate.month+"-"+endDate.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000+24*60*60;
				}
			});
			if(pictureCategory){
				/*移动图片*/
				$("#"+picture_move).click(function(){
					var html="";
					html=html+"<form class='layui-form picture-layer-form' lay-filter='"+picture_manage+"_filter'>"+createMediaFormFieldHtml({label:t('selectGroup', '选择分组'),fieldHtml:"<select id='"+picture_manage+"_select' class='layui-select'>"});
					html=html+(category_tree ? category_tree.buildMoveOptionsHtml() : "<option value='0'>"+t('allPictures', '所有图片')+"</option>");
					html=html+"</select></div></div></form>";
					if(multiple==false){
						var arr = Object.keys(picture_data); 
						if(arr.length>0){
							layer.open({
								type: 1,
								title: t('movePicture', '移动图片'),
								closeBtn: 1,
								shadeClose: false,
								skin: pictureDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: pictureDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', picture_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									$.ajax({
										type:'post',
										dataType:'json',
										url:pictureMoveUrl,
										data:{id:picture_data['id'],category_id:$("#"+picture_manage+'_select').val()},
										success:function(result){
											layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												$("#"+picture_item+"_"+picture_data['id']).remove();
												picture_data={};
												syncState();
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectPictureToMove', '请选择要移动的图片?'));
						}
					}else{
						if(picture_data_multiple.length>0){
							layer.open({
								type: 1,
								title: t('movePicture', '移动图片'),
								closeBtn: 1,
								shadeClose: false,
								skin: pictureDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: pictureDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', picture_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									var ids=Array();
									for(let i in picture_data_multiple){
										ids.push(picture_data_multiple[i]['id']);
									}
									$.ajax({
										type:'post',
										dataType:'json',
										url:pictureMoveUrl,
										data:{id:ids,category_id:$("#"+picture_manage+'_select').val()},
										success:function(result){
											layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												for(let i in picture_data_multiple){
													$("#"+picture_item+"_"+picture_data_multiple[i]['id']).remove();
												}
												picture_data_multiple=Array();
												syncState();
												updatePictureSelectedCount();
												syncPictureSelectAll();
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectPictureToMove', '请选择要移动的图片?'));
						}
					}
				});
			}
			/*删除事件*/
			$("#"+picture_del).click(function(){
				if(multiple==false){
					var arr = Object.keys(picture_data); 
					if(arr.length>0){
						layer.open({
							type: 1,
							title: t('deletePicture', '删除图片'),
							closeBtn: 1,
							shadeClose: false,
							skin: pictureDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: pictureDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeletePictures', '真的要删除选择的图片吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								$.ajax({
									type:'post',
									dataType:'json',
									url:pictureDelUrl,
									data:{id:picture_data['id']},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											$("#"+picture_item+"_"+picture_data['id']).remove();
											picture_data={};
											syncState();
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectPictureToDelete', '请选择要删除的图片?'));
					}
				}else{
					if(picture_data_multiple.length>0){
						layer.open({
							type: 1,
							title: t('deletePicture', '删除图片'),
							closeBtn: 1,
							shadeClose: false,
							skin: pictureDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: pictureDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeletePictures', '真的要删除选择的图片吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							success: function(layero, index){
								
							},
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								var ids=Array();
								for(let i in picture_data_multiple){
									ids.push(picture_data_multiple[i]['id']);
								}
								$.ajax({
									type:'post',
									dataType:'json',
									url:pictureDelUrl,
									data:{id:ids},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											for(let i in picture_data_multiple){
												$("#"+picture_item+"_"+picture_data_multiple[i]['id']).remove();
											}
											picture_data_multiple=Array();
											updatePictureSelectedCount();
											syncPictureSelectAll();
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectPictureToDelete', '请选择要删除的图片?'));
					}
				}
			});
			/*搜索事件*/
			$("#"+picture_search_btn).click(function(data){
				uploadPicture.reload({data:{category_id:category_id}});
				var load=layer.load();
				if($("#"+picture_search_date).val()==''){
					picture_s_time=0;
					picture_e_time=0;
				}
				$.ajax({
					type:'post',
					dataType:'json',
					url:pictureUrl,
					data:{s_time:picture_s_time,e_time:picture_e_time,page:1,category_id:category_id,name:$("#"+picture_search_input).val()},
				success:function(result){
					layer.close(load);
					$("#"+picture_content).empty();
						var list = result.data;
						picture_total=result.count;
						for(var i=0;i<list.length;i++){
							$("#"+picture_content).append("<a data-id='"+list[i].id+"' data-src='"+escapeHtml(list[i].small_pic)+"' data-path='"+escapeHtml(list[i].path)+"' id='"+picture_item+'_'+list[i].id+"'><img src='"+escapeHtml(list[i].small_pic)+"'/><label class='picture_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye picture-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
						applyPictureSelections();
						bindPictureItems();
						/*编辑文件名*/
						$("#"+picture_content+" a label i").off();
						$("#"+picture_content+" a label i").click(function(event){
							event.stopPropagation();
							that=$(this).parent();
							if($(this).hasClass('picture-preview-trigger')){
								openImagePreview(that.parent().attr('data-path'));
							}
							if($(this).hasClass('layui-icon-edit')){
								var name=that.find('span').text();
								var tmp_id=that.attr('data');
								layer.open({
									type: 1,
									title: t('renameFile', '修改文件名【{name}】', {name: name}),
									closeBtn: 1,
									shadeClose: false,
									skin: 'layui-layer-g3ys-form',
									resize:false,
									scrollbar:false,
									area: ['470px', '230px'],
									content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
									btn: [t('confirm', '确定'), t('cancel', '取消')],
									yes:function(index, layero){
										layer.close(index);
										var tmp_val=trimText($(layero).find('input').val());
										if(tmp_val!=''){
											var load=layer.load();
											$.ajax({
												type:'post',
												dataType:'json',
												url:editPictureNameUrl,
												data:{id:tmp_id,name:tmp_val},
												success:function(result){
													layer.close(load);
													if(result.code==0){
														layer.msg(t('renameSuccess', '修改成功'));
														$(".picture_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
													}else{
														layer.msg(t('renameFailed', '修改失败'));
													}
												}
											})
										}else{
											layer.msg(t('fileNameRequired', '文件名不能为空'));
										}
									}
								});
							}
						});
						laypage.render({
							elem: picture_page
							,count: picture_total
							,limit:20
							,jump: function(obj, first){
								if(!first){
									$("#"+picture_content).empty();
									$.ajax({
										type:'post',
										dataType:'json',
										url:pictureUrl,
										data:{s_time:picture_s_time,e_time:picture_e_time,page:obj.curr,category_id:category_id},
										success:function(result){
											$("#"+picture_content).empty();
											var list = result.data;
											for(var i=0;i<list.length;i++){
												$("#"+picture_content).append("<a data-id='"+list[i].id+"' data-src='"+escapeHtml(list[i].small_pic)+"' data-path='"+escapeHtml(list[i].path)+"' id='"+picture_item+"_"+list[i].id+"'><img src='"+escapeHtml(list[i].small_pic)+"'/><label class='picture_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye picture-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
											}
											$("#"+picture_content+" a").click(function(){
												if($(this).hasClass('picture-item-select')){
													$(this).removeClass('picture-item-select');
													let tmp_id=$(this).attr('data-id');
													if(multiple==false){
														picture_data={};
														syncState();
													}else{
														for(let i in picture_data_multiple){
															if(picture_data_multiple[i]['id']==tmp_id){
																picture_data_multiple.splice(i,1);
															}
														}
														$("#"+picture_select_all_num).text(picture_data_multiple.length);
													}
												}else{
													if(multiple==false){
														$("#"+picture_content+" a").removeClass('picture-item-select');
														picture_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),src:$(this).attr('data-src'),title:$(this).find('span').text()};
														syncState();
													}else{
														if(picture_data_multiple.length>=pictureMax){
															layer.msg(t('maxSelect', '最多只能选{max}张', {max: pictureMax}));
															return false;
														}else{
															var tmp_picture_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),src:$(this).attr('data-src'),title:$(this).find('span').text()};
															picture_data_multiple.push(tmp_picture_data);
															$("#"+picture_select_all_num).text(picture_data_multiple.length);
															$(this).addClass('picture-item-select');
														}
													}
													$(this).addClass('picture-item-select');
												}
											});
											/*编辑文件名*/
										$("#"+picture_content+" a label i").off();
										$("#"+picture_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											
											if($(this).hasClass('picture-preview-trigger')){
												openImagePreview(that.parent().attr('data-path'));
											}
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editPictureNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".picture_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
										}
									})
								}
							}
						});
					}
				});
				mobilePanels && mobilePanels.closeSearch();
				return false;
			});
		
		/*初始上传按钮*/
		var uploadPicture=upload.render({
			elem: '#'+picture_upload
			,url: pictureUploadUrl
			,field:field||'file'
			,acceptMime:acceptMime||'image/png,image/gif,image/jpeg,image/webp,image/bmp'
			,size:size||2*1024*1024
			,headers:headers||''
			,exts:exts||'jpg|gif|png|jpeg|pneg|webp|bmp'
			,data:pictureUploadData||''
			,multiple:multiple
			,before:function(obj){
				layer.load();
			}
			,done: function(result){
				layer.closeAll('loading'); 
				if(result.code=='0'){
					$("#"+picture_content).prepend("<a data-id='"+result.data.id+"' data-src='"+escapeHtml(result.data.small_pic)+"' data-path='"+escapeHtml(result.data.path)+"'  id='"+picture_item+'_'+result.data.id+"'><img src='"+escapeHtml(result.data.small_pic)+"'/><label class='picture_item_label' data='"+result.data.id+"'><span>"+escapeHtml(result.data.name)+"</span><i class='layui-icon layui-icon-eye picture-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
					applyPictureSelections();
					bindPictureItems();
					/*编辑文件名*/
					$("#"+picture_content+" a label i").off();
					$("#"+picture_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('picture-preview-trigger')){
							openImagePreview(that.parent().attr('data-path'));
						}
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editPictureNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".picture_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});
					setPictureItemSelected($("#"+picture_item+"_"+result.data.id), true);
				}else{
					layer.msg(result.msg);
				}
			}
		});
		if(pictureCategory){
			/*添加分类*/
			$("#"+picture_category_add).off();
			category_tree = createMediaCategoryTree({
				elem: "#"+picture_category,
				addButton: "#"+picture_category_add,
				categoryUrl: pictureCategoryUrl,
				updateUrl: pictureCategoryUpdateUrl,
				deleteUrl: pictureCategoryDelUrl,
				allLabel: t('allPictures', '所有图片'),
				getSelectedId: function(){
					return category_id;
				},
				setSelectedId: function(value){
					category_id = value;
					syncState();
				},
				onSelect: function(){
					$("#"+picture_search_btn).click();
					mobilePanels && mobilePanels.closeCategory();
				},
				texts: {
					addGroup: t('addGroup', '添加分组'),
					newGroup: t('newGroup', '新建分组'),
					groupName: t('groupName', '分组名称'),
					groupNameRequired: t('groupNameRequired', '请填写分组名称'),
					confirm: t('confirm', '确定'),
					cancel: t('cancel', '取消'),
					edit: t('edit', '修改'),
					delete: t('delete', '删除'),
					deleteGroup: t('deleteGroup', '删除分组'),
					confirmDeleteGroup: t('confirmDeleteGroup', '真的要删除该分组吗?'),
					deleteGroupWithChildren: t('deleteGroupWithChildren', '请先删除子分组'),
					renameSuccess: t('renameSuccess', '修改成功'),
					renameFailed: t('renameFailed', '修改失败'),
					deleteSuccess: t('deleteSuccess', '删除成功'),
					deleteFailed: t('deleteFailed', '删除失败')
				}
			});
			init_categorys = category_tree.reload;
			syncState();

			init_categorys();
		}
		/*获取图片*/
		$.ajax({
				type:'post',
				dataType:'json',
				url:pictureUrl,
				data:{s_time:picture_s_time,e_time:picture_e_time,page:1,category_id:category_id},
				success:function(result){
					$("#"+picture_content).empty();
					var list = result.data;
					picture_total=result.count;
					if(list){
						for(var i=0;i<list.length;i++){
							$("#"+picture_content).append("<a data-id='"+list[i].id+"' data-src='"+escapeHtml(list[i].small_pic)+"' data-path='"+escapeHtml(list[i].path)+"' id='"+picture_item+"_"+list[i].id+"'><img src='"+escapeHtml(list[i].small_pic)+"'/><label class='picture_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye picture-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
					}
					applyPictureSelections();
					bindPictureItems();
					/*编辑文件名*/
					$("#"+picture_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('picture-preview-trigger')){
							openImagePreview(that.parent().attr('data-path'));
						}
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editPictureNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".picture_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});

					laypage.render({
						elem: picture_page
						,count: picture_total
						,limit:20
						,jump: function(obj, first){

							if(!first){
								$.ajax({
									type:'post',
									dataType:'json',
									url:pictureUrl,
									data:{s_time:picture_s_time,e_time:picture_e_time,page:obj.curr,category_id:category_id},
									success:function(result){
										$("#"+picture_content).empty();
										var list = result.data;
										for(var i=0;i<list.length;i++){
											$("#"+picture_content).append("<a data-id='"+list[i].id+"' data-src='"+list[i].small_pic+"' data-path='"+list[i].path+"' id='"+picture_item+"_"+list[i].id+"'><img src='"+list[i].small_pic+"'/><label class='picture_item_label' data='"+list[i]['id']+"'><span>"+list[i].name+"</span><i class='layui-icon layui-icon-eye picture-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
										}
										applyPictureSelections();
										bindPictureItems();

										/*编辑文件名*/
										$("#"+picture_content+" a label i").off();
										$("#"+picture_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											if($(this).hasClass('picture-preview-trigger')){
												openImagePreview(that.parent().attr('data-path'));
											}
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editPictureNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".picture_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
									}
								})
							}
						}
					});
				}
			});
			
		}
		
		
		var layerOptions = getMediaManageLayerOptions();
		this.options.layer=layer.open({
			  type: 1,
			  title: t('selectPicture', '选择图片'),
			  closeBtn: 1,
			  shadeClose: false,
			  skin: 'layui-layer-g3ys-form-big media-manage-layer',
			  resize:false,
			  scrollbar:false,
			  area: layerOptions.area,
			  offset: layerOptions.offset,
			  content: $('#'+picture_manage_div),
			  success: function(layero, index){
					mobilePanels = bindMediaMobilePanels({
						shellId: picture_manage,
						categoryTriggerId: pictureCategory ? picture_mobile_category_toggle : '',
						searchTriggerId: picture_mobile_search_toggle
					});
					bindMediaDialogFooter({
						confirmId: picture_confirm,
						cancelId: picture_cancel,
						onConfirm: function(){
							syncSelectedPicturesFromDom();
							layer.close(index);
							if(multiple){
								if(picture_data_multiple.length>0){
									for(let i in picture_data_multiple){
										let item=picture_data_multiple[i];
										var arr = Object.keys(item);
										(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',item['id'],item['path'],item['src'],item['title']);
									}
									picture_data_multiple=Array();
									syncState();
									$("#"+picture_select_all).prop('checked',false);
									$("#"+picture_content+" a").removeClass("picture-item-select");
									updatePictureSelectedCount();
								}
							}else{
								var arr = Object.keys(picture_data); 
								(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',picture_data['id'],picture_data['path'],picture_data['src'],picture_data['title']);
								picture_data={};
								syncState();
								$("#"+picture_content+" a").removeClass("picture-item-select");
							}
							$("#"+picture_manage_div).hide();
						},
						onCancel: function(){
							layer.close(index);
						}
					});
					$("#"+picture_manage_div).show();
					layer.close(load);
			  },
			  end:function(){
					$("#"+picture_manage_div).hide();
			  }
		});
	}
	pictureManage.prototype.close=function(){
		layer.close(this.options.layer);
	}
export { PictureManage as pictureManage };
